import { array, object, string } from 'yup';
import {
  email,
  name,
  phone,
  postalCode,
  requiredFieldFunction,
} from '../../helpers/yupValidations';
import { t } from 'i18next';

export const API_ROUTES = {
  CONSUMER_LIST_FOR_HRA: {
    METHOD: 'POST',
    URL: 'agent/consumer-list-for-hra',
  },
  SIGNED_CONSUMER_LIST: {
    METHOD: 'GET',
    URL: 'agent/signed-consent-consumer-list',
  },
  CARRIER_LIST: {
    METHOD: 'GET',
    URL: 'agent/carrier-list',
  },
  HRA_DELETE: {
    METHOD: 'POST',
    URL: '/hra/delete',
  },
  HRA_DETAILS: {
    METHOD: 'POST',
    URL: 'consumer/hra-details',
  },
  GET_HRA_CARRIER_COUNT: {
    METHOD: 'GET',
    URL: '/dashboard/get-hra-carrier-count',
  },
  GET_HRA_STATE_COUNT: {
    METHOD: 'GET',
    URL: '/dashboard/get-hra-state-count',
  },

  //for agreement
  SEND_HRA_AGREEMENT_CONSENT: {
    METHOD: 'POST',
    URL: 'agent/send-hra-agreement-consent',
  },
  GET_HRA_AGREEMENT_SIGNED_DOC_STATUS: {
    METHOD: 'POST',
    URL: 'agent/get-hra-agreement-signed-doc-status',
  },
  HRA_SIGN_AGREEMENT: {
    METHOD: 'POST',
    URL: 'agent/sign-document',
  },
  //for consent
  SEND_HRA_CONSENT: {
    METHOD: 'POST',
    URL: 'agent/send-hra-consent',
  },
  GET_HRA_SIGNED_DOC_STATUS: {
    METHOD: 'POST',
    URL: 'consumer/get-hra-signed-doc-status',
  },
  HRA_SIGN_CONSENT: {
    METHOD: 'POST',
    URL: 'consumer/sign-document',
  },

  // hra form for consumer
  GET_HRA_FORM_DOC_STATUS: {
    METHOD: 'POST',
    URL: 'consumer/get-hra-form-doc-status',
  },
  HRA_SIGN_FORM: {
    METHOD: 'POST',
    URL: 'consumer/sign-form-document',
  },

  //agent role
  HRA_AGENT_LIST: {
    METHOD: 'GET',
    URL: 'hra/agent-list',
  },
};
export const diagnosedOptions = [
  {
    label: 'Diabetes',
    value: 'diabetes',
  },
  {
    label: 'Hypertension (High Blood Pressure)',
    value: 'hypertension',
  },
  {
    label: 'Heart Disease',
    value: 'heart_disease',
  },
  {
    label: 'Stroke',
    value: 'stroke',
  },
  {
    label: 'High Cholesterol',
    value: 'high_cholestrol',
  },
  {
    label: 'Cancer',
    value: 'cancer',
  },
  {
    label: 'Chronic Kidney Disease',
    value: 'chronic_kidney_disease',
  },
  {
    label: 'Liver Disease',
    value: 'liver_disease',
  },

  {
    label: 'Asthma or Chronic Obstructive Pulmonary Disease (COPD)',
    value: 'copd',
  },

  {
    label: 'Others (please specify)',
    value: 'others',
  },
];
export const familyDiagnosedOptions = [
  {
    label: 'Heart Disease',
    value: 'heart_disease',
  },
  {
    label: 'Cancer',
    value: 'cancer',
  },
  {
    label: 'Diabetes',
    value: 'diabetes',
  },
  {
    label: 'Hypertension (High Blood Pressure)',
    value: 'hypertension',
  },
  {
    label: 'Mental Health Disorders',
    value: 'mental_health_disorders',
  },
  {
    label: 'Stroke',
    value: 'stroke',
  },

  {
    label: 'Others (please specify)',
    value: 'others',
  },
];
export const addictionUseArr = [
  {
    label: 'Tobacco ',
    value: 'tobacco',
  },
  {
    label: `Alcohol`,
    value: 'alcohol',
  },
  {
    label: 'Recreational Drugs',
    value: 'recreational_drugs',
  },
];
export const yesNoQuestionsArr = [
  {
    label: 'PrescriptionMedications',
    value: 'prescription_medications',
  },
  {
    label: 'Allergies',
    value: 'allergies',
  },
  {
    label: 'Surgeries',
    value: 'surgery_in_past_5_years',
  },
  {
    label: 'ChronicPain',
    value: 'chronic_pain',
  },
];

export const yesOrNo = {
  yes: t('translation:labels.Yes'),
  // yes: 'Yes',
  no: 'No',
};

export const sleepCycleOptions = [
  {
    label: 'Less than 5 hours',
    value: 'less_than_5',
  },
  {
    label: '5 to 6 hours',
    value: 'five_to_six',
  },
  {
    label: '7 to 8 hours',
    value: 'seven_to_eight',
  },
  {
    label: 'More than 8 hours',
    value: 'more_than_eight',
  },
];

export const exerciseOptions = [
  {
    label: 'Never',
    value: 'never',
  },
  {
    label: '1 to 2 days per week',
    value: 'one_to_two_day',
  },
  {
    label: '3 to 4 days per week',
    value: 'three_to_four_day',
  },
  {
    label: '5 or more days per week',
    value: 'five_or_more_day',
  },
];

export const stressLevelOptions = [
  {
    label: 'Low',
    value: 'low',
  },
  {
    label: 'Moderate',
    value: 'moderate',
  },
  {
    label: 'High',
    value: 'high',
  },
  {
    label: 'Very High',
    value: 'very_high',
  },
];

export const dietOptions = [
  {
    label: 'Poor',
    value: 'poor',
  },
  {
    label: 'Fair',
    value: 'fair',
  },
  {
    label: 'Good',
    value: 'good',
  },
  {
    label: 'Excellent',
    value: 'excellent',
  },
];

export const pastYearOptions = [
  {
    label: 'Never',
    value: 'never',
  },
  {
    label: 'Within the past year',
    value: 'within_past_year',
  },
  {
    label: '1 to 3 years ago',
    value: 'one_to_three_year_ago',
  },
  {
    label: 'More than 3 years ago',
    value: 'more_than_three_year_ago',
  },
];

export const psaTestOptions = [
  {
    label: 'Never',
    value: 'never',
  },
  {
    label: 'Within the past year',
    value: 'within_past_year',
  },
  {
    label: 'More than a year ago',
    value: 'more_than_a_year_ago',
  },
];

export const vaccinationOptions = [
  {
    label: 'Influenza (flu) vaccine',
    value: 'influe',
  },
  {
    label: 'Pneumococcal vaccine',
    value: 'pneumoococcal',
  },
  {
    label: 'COVID-19 vaccine',
    value: 'covid_19',
  },
  {
    label: 'Tetanus booster',
    value: 'tetnus',
  },
  {
    label: 'Shingles vaccine',
    value: 'shingles',
  },
  {
    label: 'Others (please specify)',
    value: 'others',
  },
];
export const timeSpanOptions = [
  {
    label: 'Never',
    value: 'never',
  },
  {
    label: 'Several days',
    value: 'several_days',
  },
  {
    label: 'More than half the days',
    value: 'more_than_half_days',
  },
  {
    label: 'Nearly every day',
    value: 'nearly_every_day',
  },
];

export const healthPrioritiesOptions = [
  {
    label: 'Weight Management',
    value: 'weight_management',
  },
  {
    label: 'Smoking Cessation',
    value: 'smoking_cessation',
  },
  {
    label: 'Managing chronic conditions',
    value: 'chronic_condition',
  },
  {
    label: 'Reducing Stress',
    value: 'reducing_stress',
  },
];

export const wellnessOptions = [
  {
    label: 'Weight Management',
    value: 'weight_management',
  },
  {
    label: 'Smoking Cessation',
    value: 'smoking_cessation',
  },
  {
    label: 'Stress Management',
    value: 'stress_management',
  },
  {
    label: 'Fitness & Exercise',
    value: 'fitness_exercise',
  },
  {
    label: 'Chronic Disease Management',
    value: 'chronic_disease_management',
  },
  {
    label: 'Nutrition',
    value: 'nutrition',
  },

  {
    label: 'Others (please specify)',
    value: 'others',
  },
];

export const genderArr = [
  { label: 'Male', value: 'Male' },
  { label: 'Female', value: 'Female' },
  { label: 'Others', value: 'Others' },
];
export const marStatusArr = [
  { label: 'Single', value: 'Single' },
  { label: 'Married', value: 'Married' },
  { label: 'Divorce', value: 'Divorce' },
];
export const exerciseArr = [
  { label: 'Walking', value: 'walking' },
  { label: 'Running', value: 'running' },
  { label: 'Weight Training', value: 'weight_training' },
  { label: 'Yoga', value: 'yoga' },
];

export const hraSchema = object({
  consumer_info: object({
    year: requiredFieldFunction('Year'),
    state: requiredFieldFunction('State'),
    city: requiredFieldFunction('City'),
    address: requiredFieldFunction('Address'),
    zipCode: postalCode,
    // zipCode: requiredFieldFunction('ZipCode'),
  }),
  member: array().of(
    object({
      relation: requiredFieldFunction('Relation'),
      data: object({
        personal_demographic_info: object({
          name,
          date_of_birth: requiredFieldFunction('DOB'),
          gender: requiredFieldFunction('Gender'),
          relation: requiredFieldFunction('Relation'),
          marital_status: requiredFieldFunction('Maritial Status'),
          phone,
          email,
          // occupation: requiredFieldFunction('Occupation'),
          // primary_care_provider: requiredFieldFunction('Provider'),
          carrierId: requiredFieldFunction('Carrier'),
        }),
        diagnosed_with_conditions_otherValue: string().when(
          'diagnosed_with_conditions',
          {
            is: (val) => {
              return val?.includes('others');
            },
            then: () => string().required('This field is required'),
            otherwise: () => string(),
          },
        ),
        family_diagnosed_with_conditions_other: string().when(
          'family_diagnosed_with_conditions',
          {
            is: (val) => {
              return val?.includes('others');
            },
            then: () => string().required('This field is required'),
            otherwise: () => string(),
          },
        ),
        typeofExValue: string().when('typeofEx', {
          is: (val) => val,
          then: () => string().required('This field is required'),
          otherwise: () => string(),
        }),
        vaccinations_received_in_past_other: string().when(
          'vaccinations_received_in_past',
          {
            is: (val) => {
              return val?.includes('others');
            },
            then: () => string().required('This field is required'),
            otherwise: () => string(),
          },
        ),

        interests_in_wellness_programs_other: string().when(
          'interests_in_wellness_programs',
          {
            is: (val) => {
              return val?.includes('others');
            },
            then: () => string().required('This field is required'),
            otherwise: () => string(),
          },
        ),
      }),
    }),
  ),
});

export const defaultValues = {
  member: [],

  consumer_info: {
    // consumerId: '',
    year: '2024',
    state: '',
    city: '',
    zipCode: '',
    address: '',
  },
};

export const relationArr = [
  {
    label: 'Self',
    value: 'Self',
  },
  {
    label: 'Brother',
    value: 'Brother',
  },
  {
    label: 'Sister',
    value: 'Sister',
  },
  {
    label: 'Mother',
    value: 'Mother',
  },
  {
    label: 'Father',
    value: 'Father',
  },
  {
    label: 'Son',
    value: 'Son',
  },
  {
    label: 'Daughter',
    value: 'Daughter',
  },
  {
    label: 'Spouse',
    value: 'Spouse',
  },
];
